import { z } from 'zod';

export const formSchema = z.object({
  loai_tg_ts: z.coerce.number().optional(),
  ma_tg_ts: z.string().nonempty('Mã tăng giảm là bắt buộc'),
  ten_tg_ts: z.string().nonempty('Tên tăng giảm là bắt buộc'),
  ten_tg_ts2: z.string().optional(),
  status: z.coerce.number().optional()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  loai_tg_ts: 1,
  ma_tg_ts: '',
  ten_tg_ts: '',
  ten_tg_ts2: '',
  status: 1
};
